module.exports = __webpack_public_path__ + "img/jira-software-blue.63abda6f.svg";